class MugCoasterCatalog extends HTMLElement {
  async connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    try {
      const response = await fetch(this.dataset.configUrl);
      if (!response.ok) throw new Error('catalogue');
      const config = await response.json();
      this.items = this.dataset.kind === 'mugs' ? config.mugCatalog : config.coasters;
      this.config = config;
      this.querySelector('[data-catalog-search]').addEventListener('input', () => this.render());
      this.render();
    } catch { this.querySelector('[data-catalog-status]').textContent = this.dataset.draft; }
  }
  render() {
    const grid = this.querySelector('[data-catalog-grid]');
    const term = this.querySelector('[data-catalog-search]').value.trim().toLocaleLowerCase();
    const cards = this.items.filter(item => item.title.toLocaleLowerCase().includes(term)).map(item => {
      const article = document.createElement('article');
      const image = document.createElement('img');
      const url = new URL(item.image, location.origin);
      url.searchParams.set('width', '600');
      image.src = url.href; image.alt = item.title; image.loading = 'lazy'; image.width = 600; image.height = 600;
      const heading = document.createElement('h2'); heading.textContent = item.title;
      const text = document.createElement('p');
      if (this.dataset.kind === 'mugs' || !this.config.reviewOnly) {
        const link = document.createElement('a'); link.href = `${this.dataset.rootUrl}products/${item.handle}${this.dataset.kind === 'coasters' ? `?variant=${item.variants[0].id}` : ''}`;
        link.append(image, heading); article.append(link); text.textContent = this.dataset.kind === 'mugs' ? this.dataset.price : this.dataset.singlePrice;
      } else {
        article.append(image, heading); text.textContent = this.dataset.draft;
      }
      if (this.dataset.kind === 'coasters' && item.variants.length > 1) {
          const select = document.createElement('select'); select.setAttribute('aria-label', `${item.title} — ${this.dataset.option}`);
          select.replaceChildren(...item.variants.map(variant => new Option(variant.title, variant.id)));
          select.addEventListener('change', () => {
            image.src = item.variants.find(variant => variant.id === select.value).image;
            const link = article.querySelector('a');
            if (link) link.href = `${this.dataset.rootUrl}products/${item.handle}?variant=${select.value}`;
          });
          article.append(select);
      }
      article.append(text); return article;
    });
    grid.replaceChildren(...cards);
    this.querySelector('[data-catalog-status]').textContent = `${cards.length} / ${this.items.length}`;
  }
}
if (!customElements.get('mug-coaster-catalog')) customElements.define('mug-coaster-catalog', MugCoasterCatalog);

